import React, { type ReactNode } from "react";

import { ErrorGlobal, Loader } from "src/components";
import { REACT_QUERY_STALE_TIME } from "src/constants";
import { useGetAccountQuery } from "src/graphql/generated/queries";
import { useUuid } from "src/hooks";
import { useAuthStore } from "src/stores/auth-store";

export const AccountWrapper = ({ children }: { children: ReactNode }) => {
  const uuid = useUuid();
  const logout = useAuthStore((state) => state.logout);

  const { data, isLoading, error } = useGetAccountQuery(
    {
      uuid,
    },
    {
      staleTime: REACT_QUERY_STALE_TIME,
    }
  );

  if (error) {
    return <ErrorGlobal onLogout={logout} />;
  }

  if (isLoading || !data) {
    return <Loader />;
  }

  return <>{children}</>;
};
